import { useEffect } from "react";
import URLService from "../service/urlService";

function RedirectToTransferQTB() {
  useEffect(() => {
    window.location.href = URLService.generateRedirectUrl(
      window._env_.REACT_APP_TRANSFER_QTB_URL
    );
  }, []);

  return null;
}

export default RedirectToTransferQTB;
